// eslint-disable-next-line import/prefer-default-export
export const productsIndexSerializer = (data = {}) => {
  const newData = { products: [] }
  const { data: { products = [] } } = data

  newData.products = products.map((product) => ({ ...product }))

  return newData
}
